import { DI_CONTAINER } from '@integration-frontends/core';
import {
  bulkDownloadAssetsInitEffects,
  deleteAssetsEffects,
  editAttachmentEffects,
  getIntegrationApplicationReducer,
  placeAttachmentEffects,
  searchAssetsEffects,
  selectAttachmentEffects,
  selectAssetEffects,
  uploadAssetsEffects,
  uploadTagsEffects,
} from '@integration-frontends/integration/core/application';
import { interfaces } from 'inversify';
import { all, fork } from 'redux-saga/effects';
import { initCommonTranslations } from './common/i18n';
import './common/i18n';
import { INTEGRATION_UI_STYLING_OPTIONS_TOKEN } from './styling-options';
import { contentLibraryUploadAssetsEffects } from '@integration-frontends/integration/core/application/content-library-upload-assets';

// TODO: Create generic module. Improve usability. ~PP
export interface IntegrationUiModuleOptions {
  locale: string;
}

export class IntegrationUiModule {
  static async initialize(
    container: interfaces.Container,
    { locale }: IntegrationUiModuleOptions = { locale: 'en' },
  ) {
    initStylingOptions(container);
    DI_CONTAINER.merge(container);

    await Promise.all([initCommonTranslations(locale)]);
  }

  static getRootReducer() {
    return getIntegrationApplicationReducer();
  }

  static getEffects() {
    return function* () {
      yield all([
        fork(editAttachmentEffects),
        fork(bulkDownloadAssetsInitEffects),
        fork(deleteAssetsEffects),
        fork(placeAttachmentEffects),
        fork(searchAssetsEffects),
        fork(selectAttachmentEffects),
        fork(selectAssetEffects),
        fork(uploadAssetsEffects),
        fork(contentLibraryUploadAssetsEffects),
        fork(uploadTagsEffects),
      ]);
    };
  }
}

function initStylingOptions(container: interfaces.Container) {
  if (!container.isBound(INTEGRATION_UI_STYLING_OPTIONS_TOKEN)) {
    container
      .bind(INTEGRATION_UI_STYLING_OPTIONS_TOKEN)
      .toConstantValue({ backgroundColor: 'white' });
  }
}
